import { render, staticRenderFns } from "./cg-event-text.vue?vue&type=template&id=7c6a0c86&scoped=true"
import script from "./cg-event-text.vue?vue&type=script&lang=js"
export * from "./cg-event-text.vue?vue&type=script&lang=js"
import style0 from "./cg-event-text.vue?vue&type=style&index=0&id=7c6a0c86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a0c86",
  null
  
)

export default component.exports